import React from "react";
import Button from "../../Common/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Formik } from "formik";
import Input from "../../Common/Input";
import * as yup from "yup";
import { Box, IconButton, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

const validateLoginForm = yup.object().shape({
    email: yup.string().email("Invalid email format").required("Email is required"),
    password: yup.string().required("Password is required"),
});

const LoginFormComponent = (props) => {
    const { submit, loading } = props;
    const [showPassword, setShowPassword] = React.useState(false);

    const initialValues = {
        email: "",
        password: "",
    };

    const handleTogglePassword = () => {
        setShowPassword((prev) => !prev);
    };

    const onFormSubmit = async (values) => {
        submit(values);
    };

    return (
        <>
            <Formik initialValues={initialValues} onSubmit={onFormSubmit} validationSchema={validateLoginForm}>
                {({ handleChange, handleBlur, handleSubmit, setFieldValue, values, touched, errors }) => (
                    <>
                        <Container maxWidth="sm" sx={{ height: "100vh" }}>
                            <Stack
                                justifyContent="center"
                                sx={{
                                    height: { xs: "100%", sm: "80vh", md: "100vh", lg: "100vh" },
                                    width: "auto",
                                    mx: 4,
                                    gap: "40px",
                                    alignItems: "center",
                                }}
                                spacing={1.5}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        flexDirection: "column",
                                        display: { xs: "flex", md: "none" },
                                        alignItems: "flex-start",
                                        justifyContent: "center",
                                        gap: "32px",
                                    }}
                                >
                                    <img src="assets/images/logo.png" alt="paquej-logo" style={{ width: "211px" }} />
                                    <Typography variant="h6" style={{ color: "#575757", fontSize: "24px" }}>
                                        Sourcing Platform for Packaging Industry
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "12px",
                                        alignItems: "flex-start",
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        align="left"
                                        sx={{
                                            fontWeight: "600",
                                            fontSize: "28px",
                                        }}
                                    >
                                        Log in to your account
                                    </Typography>

                                    <Typography
                                        variant="subtitle2"
                                        align="center"
                                        sx={{ fontSize: "15px", color: "#575757" }}
                                    >
                                        Welcome back! Please enter your details.
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "16px",
                                    }}
                                >
                                    <Input
                                        fullWidth
                                        label="Email"
                                        placeholder="Enter your email"
                                        id="email"
                                        name="email"
                                        onChange={(e) => {
                                            setFieldValue("email", e.target.value);
                                        }}
                                        onBlur={handleBlur("email")}
                                        value={values.email}
                                        error={errors.email && Boolean(errors.email)}
                                        helperText={errors.email}
                                    />

                                    <Input
                                        type={showPassword ? "text" : "password"}
                                        fullWidth
                                        label="Password"
                                        placeholder="Enter your password"
                                        id="password"
                                        name="password"
                                        onChange={(e) => {
                                            setFieldValue("password", e.target.value);
                                        }}
                                        onBlur={handleBlur("password")}
                                        value={values.password}
                                        error={errors.password && Boolean(errors.password)}
                                        helperText={errors.password}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        aria-label="toggle password visibility"
                                                        onClick={handleTogglePassword}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />

                                    <Button onClick={handleSubmit} loading={loading} fullWidth size="large">
                                        Sign In
                                    </Button>
                                </Box>
                            </Stack>
                        </Container>
                    </>
                )}
            </Formik>
        </>
    );
};

export default LoginFormComponent;
